<template>
  <div id="award-report" class="premium-award-report">
    <v-card class="main-card">
      <v-card-title class="text-h5 header-section">
        <h2 class="headline-text">{{ PageTitle }}</h2>
        <v-spacer></v-spacer>
        <v-btn
          @click.prevent="refreshPageData"
          color="#43aa8b"
          min-width="120"
          rounded
          elevation="2"
          class="refresh-btn white--text"
        >
          <v-icon left size="20" class="mr-1">mdi-refresh</v-icon>
          Refresh
        </v-btn>
      </v-card-title>
      <v-card-text class="content-section">
        <v-form
          ref="form1"
          v-model="valid1"
          lazy-validation
          v-on:submit.prevent="searchForm"
          class="search-form"
        >
          <div
            class="d-flex justify-content-center mt-2 mb-3"
            v-if="LoadingFlag"
          >
            <b-spinner
              variant="primary"
              type="grow"
              label="Loading..."
            ></b-spinner>
          </div>
          <v-row class="form-row">
            <v-col cols="12" sm="6" lg="3" md="6">
              <h6 class="field-label">
                <span class="text-danger">*</span> Award Category
              </h6>
              <v-autocomplete
                :reduce="(option) => option.value"
                :items="AwardCategoryOptions"
                :rules="AwardCategoryRules"
                v-model="AwardCategory"
                dense
                clearable
                required
                outlined
                class="premium-field"
                hide-details="auto"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="6">
              <h6 class="field-label">Award Group <small>(optional)</small></h6>
              <v-autocomplete
                :reduce="(option) => option.value"
                :items="AwardGroupOptions"
                :rules="AwardGroupRules"
                v-model="AwardGroup"
                dense
                clearable
                required
                outlined
                multiple
                chips
                deletable-chips
                class="premium-field"
                hide-details="auto"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="6">
              <h6 class="field-label">
                Award Status <small>(optional)</small>
              </h6>
              <v-autocomplete
                :reduce="(option) => option.value"
                :items="AwardStatusOptions"
                :rules="AwardStatusRules"
                v-model="AwardStatus"
                dense
                clearable
                required
                outlined
                class="premium-field"
                hide-details="auto"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="6">
              <h6 class="field-label">Award Type <small>(optional)</small></h6>
              <v-autocomplete
                :reduce="(option) => option.value"
                :items="AwardTypeOptions"
                v-model="AwardType"
                :loading="AwardTypeOptionsLoading"
                dense
                clearable
                required
                outlined
                class="premium-field"
                hide-details="auto"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="6">
              <h6 class="field-label">Zone <small>(optional)</small></h6>
              <v-autocomplete
                :reduce="(option) => option.value"
                :items="ZoneCodeOptions"
                :rules="ZoneCodeRules"
                :loading="ZoneCodeOptionsLoading"
                v-model="ZoneCode"
                :disabled="ZpFlag"
                :clearable="!ZpFlag"
                dense
                required
                outlined
                class="premium-field"
                hide-details="auto"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="6">
              <h6 class="field-label">LO <small>(optional)</small></h6>
              <v-autocomplete
                :reduce="(option) => option.value"
                :items="LomCodeOptions"
                :rules="LomCodeRules"
                :loading="LomCodeOptionsLoading"
                v-model="LomCode"
                dense
                clearable
                required
                outlined
                class="premium-field"
                hide-details="auto"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" lg="3" md="6" v-if="!ZpFlag">
              <h6 class="field-label">
                Award Register No <small>(optional)</small>
              </h6>
              <v-text-field
                v-model="AwardRegisterNo"
                dense
                clearable
                outlinedS
                class="premium-field"
                hide-details="auto"
                placeholder="Enter register number"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="button-row">
            <v-col cols="12" sm="12" lg="12" md="12" align="center">
              <v-btn
                :disabled="!valid1"
                @click.prevent="searchForm"
                :loading="SubmitFlag"
                medium
                rounded
                elevation="3"
                color="#1db954"
                class="action-button search-btn white--text px-5 py-2"
              >
                <v-icon left size="18" class="mr-1">mdi-magnify</v-icon>
                Search
              </v-btn>
              <v-btn
                @click.prevent="resetAll"
                medium
                rounded
                elevation="2"
                color="brown"
                class="action-button reset-btn white--text px-5 py-2 ml-3"
              >
                <v-icon left size="18" class="mr-1">mdi-refresh</v-icon>
                Reset
              </v-btn>
            </v-col>
          </v-row>
          <div class="records-count-container">
            <h3 class="records-count">{{ tableData1.length }} records found</h3>
          </div>

          <v-container
            v-if="tableData1.length > 0"
            class="award-summary-container"
          >
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-card
                  class="summary-card elevation-4"
                  :class="{ 'loading-card': CardLoadingFlag }"
                  color="#4d908e"
                >
                  <v-card-text class="summary-card-content">
                    <div v-if="CardLoadingFlag">
                      <br />
                      <v-col cols="12" v-for="n in 3" :key="n">
                        <v-skeleton-loader type="text"></v-skeleton-loader>
                        <br />
                      </v-col>
                    </div>
                    <div v-else>
                      <div class="summary-icon-container">
                        <v-icon color="#ffffff" size="38" class="summary-icon"
                          >mdi-star-check</v-icon
                        >
                      </div>
                      <h5 class="summary-title">Scored Awards</h5>
                      <h1 class="summary-value">{{ TotalScored }}</h1>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-card
                  class="summary-card elevation-4"
                  :class="{ 'loading-card': CardLoadingFlag }"
                  color="#43aa8b"
                >
                  <v-card-text class="summary-card-content">
                    <div v-if="CardLoadingFlag">
                      <br />
                      <v-col cols="12" v-for="n in 3" :key="n">
                        <v-skeleton-loader type="text"></v-skeleton-loader>
                        <br />
                      </v-col>
                    </div>
                    <div v-else>
                      <div class="summary-icon-container">
                        <v-icon color="#ffffff" size="38" class="summary-icon"
                          >mdi-send-check</v-icon
                        >
                      </div>
                      <h5 class="summary-title">Submitted Awards</h5>
                      <h1 class="summary-value">{{ TotalSubmitted }}</h1>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-card
                  class="summary-card elevation-4"
                  :class="{ 'loading-card': CardLoadingFlag }"
                  color="#f3722c"
                >
                  <v-card-text class="summary-card-content">
                    <div v-if="CardLoadingFlag">
                      <br />
                      <v-col cols="12" v-for="n in 3" :key="n">
                        <v-skeleton-loader type="text"></v-skeleton-loader>
                        <br />
                      </v-col>
                    </div>
                    <div v-else>
                      <div class="summary-icon-container">
                        <v-icon color="#ffffff" size="38" class="summary-icon"
                          >mdi-content-save-edit</v-icon
                        >
                      </div>
                      <h5 class="summary-title">Partially Saved Awards</h5>
                      <h1 class="summary-value">{{ TotalParticallySaved }}</h1>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <v-container class="data-container" v-if="tableData1.length > 0">
            <v-row class="actions-row">
              <v-col align="center" cols="12" md="12">
                <div class="action-buttons-container">
                  <json-excel
                    v-if="tableData1.length > 0 && DownloadFlag"
                    :name="ExcelFileName"
                    :data="tableData1"
                    :fields="ExcelFields"
                  >
                    <v-btn
                      color="#3f51b5"
                      rounded
                      elevation="2"
                      class="download-btn white--text px-4"
                    >
                      <v-icon left size="18" class="mr-1">mdi-download</v-icon>
                      Download Excel
                    </v-btn>
                  </json-excel>
                </div>
              </v-col>
            </v-row>

            <v-row class="mt-2" v-if="RoleId == 2 && !ZpFlag">
              <v-col class="text-center" cols="12">
                <v-btn
                  @click="deleteAlert(1)"
                  medium
                  rounded
                  elevation="2"
                  color="#FF8A65"
                  class="action-btn px-4 mr-3 white--text"
                >
                  <v-icon left size="18" class="mr-1">mdi-unlink</v-icon>
                  Unmap Award
                </v-btn>
                <v-btn
                  @click="deleteAlert(2)"
                  medium
                  rounded
                  elevation="2"
                  color="#26A69A"
                  class="action-btn px-4 mr-3 white--text"
                >
                  <v-icon left size="18" class="mr-1">mdi-delete</v-icon>
                  Delete Answer
                </v-btn>
                <v-btn
                  @click="updateRecord()"
                  :loading="UpdateLoadingFlag"
                  medium
                  rounded
                  elevation="2"
                  color="primary"
                  class="action-btn px-4 mr-3 white--text"
                >
                  <v-icon left size="18" class="mr-1">mdi-sync</v-icon>
                  Update Award
                </v-btn>
              </v-col>
            </v-row>

            <v-row class="table-row mt-3">
              <v-col cols="12">
                <v-card class="data-table-card elevation-3">
                  <v-card-text class="pa-0">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search in results..."
                      class="mx-4 mt-4 search-field"
                      dense
                      outlined
                      hide-details
                    ></v-text-field>

                    <v-data-table
                      class="premium-data-table mt-2"
                      v-model="selected1"
                      :search="search"
                      :item-key="tableOptions1.ItemKey"
                      :single-select="tableOptions1.SingleSelectFlag"
                      :show-select="tableOptions1.ShowSelectFlag"
                      :headers="tableColumns1"
                      :items="tableData1"
                      :items-per-page="tableOptions1.ItemsPerPage"
                      :footer-props="tableOptions1.FooterProps"
                      :loading="false"
                      loading-text="Loading data... Please wait"
                    >
                      <template v-slot:[`item.AwardStatusTxt`]="{ item }">
                        <v-chip
                          :color="item.AwardStatusColor"
                          draggable
                          dark
                          small
                        >
                          {{ item.AwardStatusTxt }}
                        </v-chip>
                      </template>

                      <template v-slot:[`item.ScoreDetail`]="{ item }">
                        <div v-if="item.JudgeScoreTxt != ''">
                          <p v-html="item.JudgeScoreTxt"></p>
                        </div>
                        <div v-else>
                          <p>NA.</p>
                        </div>
                      </template>

                      <template v-slot:[`item.FinalScore`]="{ item }">
                        <div v-if="item.JudgeScoreTxt != ''">
                          <p v-html="item.FinalScore"></p>
                        </div>
                        <div v-else>
                          <p>NA.</p>
                        </div>
                      </template>

                      <template v-slot:[`item.Actions`]="{ item }">
                        <v-tooltip bottom v-if="item.PreviewButtonFlag">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              color="primary"
                              @click="previewAlert(item)"
                              v-bind="attrs"
                              v-on="on"
                              class="action-icon-btn"
                            >
                              <v-icon size="20">mdi-file-search</v-icon>
                            </v-btn>
                          </template>
                          <span>Preview</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="item.EditButtonFlag">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              color="orange"
                              @click="editAlert(item)"
                              v-bind="attrs"
                              v-on="on"
                              class="action-icon-btn"
                            >
                              <v-icon size="20">mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <!-- Preview Dialog -->
        <v-dialog v-model="previewRecordPrompt" persistent max-width="80%">
          <awards-preview
            :previewRecordPrompt="previewRecordPrompt"
            :recordData="recordData"
            @hidePreviewRecordPrompt="hidePreviewRecordPrompt($event)"
            v-if="previewRecordPrompt"
          />
        </v-dialog>
        <!-- Edit Dialog -->
        <v-dialog v-model="editRecordPrompt" persistent max-width="80%">
          <awards-edit
            :editRecordPrompt="editRecordPrompt"
            :recordData="recordData"
            @hideEditRecordPrompt="hideEditRecordPrompt($event)"
            v-if="editRecordPrompt"
          />
        </v-dialog>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import AwardsPreview from "@/view/pages/erp/jci-award/AwardsPreview.vue";
import AwardsEdit from "@/view/pages/erp/jci-award/AwardScoreEdit.vue";

export default {
  mixins: [common],
  components: { AwardsPreview, AwardsEdit },
  data() {
    return {
      valid1: true,
      LoadingFlag: false,
      SubmitFlag: false,
      OverlayLoadingFlag: false,
      CardLoadingFlag: false,
      UpdateLoadingFlag: false,
      search: "",

      ProgessStart: 0,
      uploadPercentage: 0,

      UserInterface: "",

      DownloadFlag: false,
      ExcelFileName: "",
      ExcelFields: {},

      ZipDownloadFlag: false,
      ZipFileName: "",

      TotalParticallySaved: 0,
      TotalSubmitted: 0,
      TotalScored: 0,

      ZoneCodeRules: [
        // (v) => !!v || "Zone is required"
      ],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      LomCodeRules: [],
      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      AwardGroupRules: [],
      AwardGroup: [],
      AwardGroupOptions: [],
      AwardGroupOptionsLoading: false,

      AwardCategoryRules: [(v) => !!v || "Award Category is required"],
      AwardCategory: "",
      AwardCategoryOptions: [
        { value: 1, text: "National Level" },
        { value: 2, text: "Zone Level" },
        { value: 4, text: "JAC National" },
      ],
      AwardCategoryOptionsLoading: false,

      AwardType: "",
      AwardTypeOptions: [],
      AwardTypeOptionsLoading: false,

      AwardStatusRules: [],
      AwardStatus: "",
      AwardStatusOptions: [
        { value: 2, text: "Scored" },
        { value: 3, text: "Submitted" },
        { value: 4, text: "Partially Saved" },
      ],
      AwardStatusOptionsLoading: false,

      AwardRegisterNo: "",

      rows: [],
      tableData1: [],
      tableOptions1: [],
      tableColumns1: [],

      recordData: {},

      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,

      ActiveStatus: "",

      valid: true,

      RoleId: 0,
      ZpFlag: false,
      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        this.RoleId = RoleId;
        console.log("RoleId=" + RoleId);
        this.ZpFlag = RoleId === 8 ? true : false;
        if (this.ZpFlag) {
          var zoneId = this.$session.get("ZoneId");
          this.ZoneCode = zoneId ? zoneId : "";
        }

        this.pageData();
      }
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions called");
      this.ZoneCodeOptionsLoading = false;
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions called");
      this.LomCodeOptionsLoading = false;
    },
    AwardGroupOptions: function () {
      console.log("watch AwardGroupOptions called");
      this.AwardGroupOptionsLoading = false;
    },
    AwardCategory: function () {
      console.log("watch AwardCategory called");
      if (!this.ZpFlag) {
        this.ZoneCode = "";
      }
      this.AwardGroup = [];
      this.AwardStatus = "";
      this.tableData1 = [];
      this.tableOptions1 = [];
      this.tableColumns1 = [];
    },
    ZoneCode: function () {
      console.log("watch Zone called");
      this.getLomCodeOptions();
      this.AwardGroup = [];
      this.AwardStatus = "";
      this.tableData1 = [];
      this.tableOptions1 = [];
      this.tableColumns1 = [];
    },
    AwardGroup: function () {
      console.log("watch AwardGroup called");
      this.AwardStatus = "";
      this.tableData1 = [];
      this.tableOptions1 = [];
      this.tableColumns1 = [];
      this.AwardType = "";
      this.AwardTypeOptions = [];
      if (this.AwardGroup.length > 0) {
        this.getAwardTypeOptions();
      }
    },
    AwardTypeOptionsLoading: function () {
      console.log("watch AwardTypeOptionsLoading called");
      this.AwardTypeOptionsLoading = false;
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "award_report",
        Action: "report_1",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getZoneCodeOptions();
      this.getAwardGroupOptions();
      // this.getAwardCategoryOptions();
      // this.searchForm();
    },
    getResult() {
      console.log("getResult called");
      this.tableData1 = [];
      this.tableOptions1 = [];
      this.tableColumns1 = [];

      this.DownloadFlag = false;
      this.ExcelFileName = "";
      this.ExcelFields = {};

      this.ZipDownloadFlag = false;
      this.ZipFileName = "";
      this.searchForm();
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      this.ZoneCodeOptionsLoading = true;
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/year-wise-lom/zone-options";
      var selectbox1_conditions_array = {
        UserInterface: 4,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var ZoneCode = this.ZoneCode;
      console.log({ ZoneCode });
      if (ZoneCode != "") {
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        message += "Zone should not be empty. ";
      }
    },
    getAwardGroupOptions() {
      console.log("getAwardGroupOptions called");
      var selectbox1_source = "AwardGroup";
      var selectbox1_destination = "AwardGroupOptions";
      var selectbox1_url = "api/award-group/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getAwardCategoryOptions() {
      console.log("getAwardCategoryOptions called");
      var selectbox1_source = "AwardCategory";
      var selectbox1_destination = "AwardCategoryOptions";
      var selectbox1_url = "api/award-category/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },

    getAwardTypeOptions() {
      console.log("getAwardTypeOptions called");
      this.AwardTypeOptionsLoading = true;
      var selectbox1_source = "AwardCategory";
      var selectbox1_destination = "AwardTypeOptions";
      var selectbox1_url = "api/award-type/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
        AwardGroup: this.AwardGroup,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    resetAll() {
      console.log("resetAll called");
      this.$refs.form1.reset();
      this.AwardRegisterNo = "";
      if (this.ZpFlag) {
        var zoneId = this.$session.get("ZoneId");
        this.ZoneCode = zoneId ? zoneId : "";
      }
      this.tableData1 = [];
      this.tableOptions1 = [];
      this.tableColumns1 = [];

      this.DownloadFlag = false;
      this.ExcelFileName = "";
      this.ExcelFields = {};

      this.ZipDownloadFlag = false;
      this.ZipFileName = "";
    },
    previewAlert(tr) {
      console.log("previewAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.recordData = tr;
        this.previewRecordPrompt = true;
      } else {
        var message = "Kindly select one record to preview";
        this.sweetAlert("warning", message, false);
      }
    },
    editAlert(tr) {
      console.log("editAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.recordData = tr;
        this.editRecordPrompt = true;
      } else {
        var message = "Kindly select one record to edit";
        this.sweetAlert("warning", message, false);
      }
    },
    hideEditRecordPrompt(flag) {
      console.log("hideEditRecordPrompt called");
      console.log({ flag });
      this.editRecordPrompt = false;
      if (flag) {
        this.searchForm();
      }
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
    },
    searchForm() {
      console.log("searchForm called");

      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      if (validate1) {
        this.DownloadFlag = false;
        this.ExcelFileName = "";
        this.ZipDownloadFlag = false;
        this.ZipFileName = "";
        this.tableData1 = [];
        this.selected1 = [];

        this.SubmitFlag = true;
        this.LoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award/lists";

        var award_category = this.AwardCategory > 0 ? this.AwardCategory : null;
        var zone = this.ZoneCode > 0 ? this.ZoneCode : null;
        var lom = this.LomCode > 0 ? this.LomCode : null;
        var award_group = this.AwardGroup.length > 0 ? this.AwardGroup : [];
        var award_status = this.AwardStatus > 0 ? this.AwardStatus : null;
        var award_register_no =
          this.AwardRegisterNo != "" ? this.AwardRegisterNo : null;

        var upload = {
          UserInterface: 1,
          Zone: zone,
          Lom: lom,
          AwardGroup: award_group,
          AwardCategory: award_category,
          AwardStatus: award_status,
          AwardType: this.AwardType,
          AwardRegisterNo: award_register_no,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = [];
        var table_content = [];
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.ProgessStart = 0;
            thisIns.SubmitFlag = false;
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);

            var options = records.TableOptions;
            thisIns.tableOptions1 = options;

            if (flag == 1) {
              thisIns.tableColumns1 = records.TableHeader;
              thisIns.tableData1 = records.TableData;

              thisIns.DownloadFlag = options.DownloadFlag;
              thisIns.ExcelFileName = options.ExcelFileName;
              thisIns.ExcelFields = options.ExcelFields;
              thisIns.ZipDownloadFlag = options.ZipDownloadFlag;
              thisIns.ZipFileName = options.ZipFileName;

              thisIns.toast("success", output);

              var tr = records.TableData;
              var scored = 0;
              var submitted = 0;
              var particallySaved = 0;
              tr.forEach((row) => {
                var status = row["AwardStatus"];
                console.log({ status });

                if (status == 2) {
                  scored = scored + 1;
                } else if (status == 3) {
                  submitted = submitted + 1;
                } else if (status == 4) {
                  particallySaved = particallySaved + 1;
                }
              });

              thisIns.TotalParticallySaved = particallySaved;
              thisIns.TotalSubmitted = submitted;
              thisIns.TotalScored = scored;
            } else {
              console.log("error=" + output);
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            thisIns.SubmitFlag = false;
            thisIns.LoadingFlag = false;
            console.log("error=" + error);
          });
      } else {
        var message = "Kindy fill required fields and then search";
        this.toast("error", message);
      }
    },
    deleteAlert(id) {
      console.log("deleteAlert called");
      console.log({ id });

      var n1 = this.selected1.length;
      var tr = this.selected1;
      console.log({ n1 }, "tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        this.selectedData = tr;
        this.UserInterface = id;
        this.confirmAlert();
      } else {
        var error = "Select atleast One Award to UnMap Awards.";
        this.sweetAlert("error", error, false);
      }
    },
    confirmAlert() {
      console.log("confirmAlert called");
      var n1 = this.selectedData.length;
      var tr = this.selectedData;
      var id = this.UserInterface;
      console.log({ n1 }, "tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        var buttonText = id == 1 ? "UnMap Award" : "Delete Answer";
        var htmlTxt = "";

        htmlTxt += "Do you want to UnMap Selected Awards?";
        htmlTxt += "<br/><br/> Awards Count : <b>" + n1 + "</b>";

        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to UnMap selected Award?",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: buttonText,
          confirmButtonColor: "#d33",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteRecord(tr, id);
          } else {
            this.sweetAlert("warning", "You cancelled the process", false);
          }
        });
      } else {
        var error = "Atleast One Award is require to UnMap.";
        this.sweetAlert("error", error, false);
      }
    },
    deleteRecord(tr, id) {
      console.log("deleteRecord called");

      console.log({ id });
      var n1 = tr.length;
      console.log({ n1 }, "tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        var Award = tr;
        console.log({ Award });

        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;

        var add_url = server_url + "api/judge-award-relation/destroy-answers";

        var upload = {
          UserInterface: id,
          Award: Award,
        };

        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = {};
        var success = "";
        var error = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            success = response.data.success;
            error = response.data.error;
            console.log("success=" + success + ", error=" + error);
            console.log({ records });

            if (flag == 1) {
              thisIns.sweetAlert("success", output, false);
              thisIns.searchForm();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
          });
      } else {
        console.log("some errors occured");
        var message = "Kindly select one member to delete";
        this.sweetAlert("error", message, false);
      }
    },
    updateRecord() {
      console.log("updateRecord called");
      var n1 = this.selected1.length;
      var tr = this.selected1;
      console.log({ n1 }, "tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        this.UpdateLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;

        var add_url = server_url + "api/award/sync-score";

        var upload = {
          UserInterface: 1,
          Award: tr,
        };

        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.UpdateLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            if (flag == 1) {
              thisIns.sweetAlert("success", output, false);
              thisIns.searchForm();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.UpdateLoadingFlag = false;
          });
      } else {
        console.log("some errors occured");
        var message = "Kindly select one award to sync score";
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    console.log("beforeMount called");

    var RoleId = this.$session.get("RoleId");
    RoleId = RoleId == (null || undefined) ? "" : RoleId;
    console.log({ RoleId });
    this.RoleId = RoleId;

    this.refreshPageData();
  },
};
</script>

<style lang="scss">
#award-report.premium-award-report {
  font-family: "Inter", "Roboto", -apple-system, BlinkMacSystemFont, sans-serif;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 20px;

  // Main card styling
  .main-card {
    border-radius: 20px !important;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12) !important;
    margin-bottom: 32px;
    background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
    border: 1px solid rgba(255, 255, 255, 0.8);
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
    }

    .header-section {
      padding: 28px 32px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      display: flex;
      align-items: center;
      position: relative;
      overflow: hidden;

      &::after {
        content: "";
        position: absolute;
        top: -50%;
        right: -50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(
          circle,
          rgba(255, 255, 255, 0.1) 0%,
          transparent 70%
        );
        animation: rotate 20s linear infinite;
      }

      .headline-text {
        font-size: 2rem;
        font-weight: 800;
        color: #ffffff;
        margin: 0;
        letter-spacing: -0.02em;
        text-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
        position: relative;
        z-index: 1;
      }

      .refresh-btn {
        font-weight: 600;
        letter-spacing: 0.03em;
        text-transform: none;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        background: rgba(255, 255, 255, 0.2) !important;
        backdrop-filter: blur(10px);
        border: 2px solid rgba(255, 255, 255, 0.3) !important;
        position: relative;
        z-index: 1;

        &:hover {
          background: rgba(255, 255, 255, 0.3) !important;
          border-color: rgba(255, 255, 255, 0.5) !important;
          transform: translateY(-2px) scale(1.05);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25) !important;
        }
      }
    }

    .content-section {
      padding: 32px;
    }
  }

  // Form styling
  .search-form {
    margin-bottom: 28px;

    .form-row {
      margin-bottom: 12px;
    }

    .field-label {
      font-size: 0.95rem;
      font-weight: 600;
      color: #2d3748;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      gap: 6px;

      small {
        color: #718096;
        font-weight: 400;
        font-style: italic;
      }

      .text-danger {
        color: #e53e3e;
        font-size: 1.1rem;
      }
    }

    .premium-field {
      margin-bottom: 20px;

      ::v-deep .v-input__slot {
        background: #ffffff !important;
        border-radius: 12px !important;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

        &:hover {
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
        }
      }

      ::v-deep fieldset {
        border-color: #e2e8f0 !important;
        border-width: 2px !important;
        border-radius: 12px !important;
      }

      ::v-deep .v-input--is-focused fieldset {
        border-color: #667eea !important;
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
      }

      ::v-deep .v-chip {
        background: linear-gradient(
          135deg,
          #667eea 0%,
          #764ba2 100%
        ) !important;
        color: white !important;
        font-weight: 500;
      }
    }

    .button-row {
      margin-top: 28px;

      .action-button {
        text-transform: none;
        font-weight: 700;
        letter-spacing: 0.03em;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border-radius: 12px !important;
        font-size: 1rem;
        padding: 24px 40px !important;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        position: relative;
        overflow: hidden;

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.3),
            transparent
          );
          transition: left 0.5s ease;
        }

        &:hover::before {
          left: 100%;
        }

        &:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2) !important;
        }

        &.search-btn {
          min-width: 160px;
          background: linear-gradient(
            135deg,
            #1db954 0%,
            #12a03d 100%
          ) !important;
        }

        &.reset-btn {
          min-width: 160px;
          background: linear-gradient(
            135deg,
            #8d5524 0%,
            #6d4419 100%
          ) !important;
        }
      }
    }
  }

  // Records count
  .records-count-container {
    text-align: center;
    margin: 32px 0;

    .records-count {
      color: #ffffff;
      font-size: 1.3rem;
      font-weight: 700;
      display: inline-block;
      padding: 12px 32px;
      border-radius: 50px;
      background: linear-gradient(135deg, #e53935 0%, #c62828 100%);
      box-shadow: 0 6px 20px rgba(229, 57, 53, 0.3);
      animation: slideUp 0.6s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;

      &::before {
        content: "📊";
        margin-right: 10px;
        font-size: 1.4rem;
      }
    }
  }

  // Summary Cards styling
  .award-summary-container {
    margin-bottom: 32px;
    animation: fadeIn 0.8s ease;

    .summary-card {
      border-radius: 20px !important;
      overflow: hidden;
      min-height: 190px;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      border: none !important;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: -50%;
        right: -50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(
          circle,
          rgba(255, 255, 255, 0.15) 0%,
          transparent 70%
        );
        transform: rotate(30deg);
        transition: transform 0.6s ease;
      }

      &:hover {
        transform: translateY(-8px) scale(1.02);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2) !important;

        &::before {
          transform: rotate(60deg);
        }

        .summary-icon-container {
          transform: scale(1.1) rotate(5deg);
        }
      }

      &.loading-card {
        background: linear-gradient(
          135deg,
          #e0e0e0 0%,
          #f5f5f5 100%
        ) !important;
        opacity: 0.9;
      }

      .summary-card-content {
        text-align: center;
        color: white;
        padding: 32px 24px;
        position: relative;
        z-index: 1;
      }

      .summary-icon-container {
        margin-bottom: 16px;
        background: rgba(255, 255, 255, 0.25);
        backdrop-filter: blur(10px);
        width: 70px;
        height: 70px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 20px;
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: 3px solid rgba(255, 255, 255, 0.3);
      }

      .summary-title {
        font-size: 1.15rem;
        font-weight: 600;
        margin-bottom: 12px;
        color: #fff;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        letter-spacing: 0.03em;
      }

      .summary-value {
        font-size: 3rem;
        font-weight: 800;
        color: #fff;
        margin: 0;
        text-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        letter-spacing: -0.02em;
      }
    }
  }

  // Data table container
  .data-container {
    .actions-row {
      margin-bottom: 24px;

      .action-buttons-container {
        display: flex;
        justify-content: center;
        gap: 16px;
        flex-wrap: wrap;
      }

      .download-btn,
      .action-btn {
        text-transform: none;
        font-weight: 600;
        letter-spacing: 0.03em;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border-radius: 12px !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        position: relative;
        overflow: hidden;

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.3),
            transparent
          );
          transition: left 0.5s ease;
        }

        &:hover::before {
          left: 100%;
        }

        &:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
        }
      }
    }

    .data-table-card {
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
      border: 1px solid rgba(0, 0, 0, 0.05);

      .search-field {
        max-width: 450px;

        ::v-deep .v-input__slot {
          background: #f8f9fa !important;
          border-radius: 12px !important;
        }
      }

      .premium-data-table {
        width: 100%;

        ::v-deep .v-data-table__wrapper {
          border-radius: 0;
        }

        ::v-deep .v-data-table-header {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);

          th {
            font-weight: 700 !important;
            color: #ffffff !important;
            font-size: 0.95rem !important;
            white-space: nowrap;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            padding: 18px 16px !important;
            border: none !important;
          }
        }

        ::v-deep .v-data-table__expanded__content {
          box-shadow: inset 0 4px 12px -4px rgba(0, 0, 0, 0.15),
            inset 0 -4px 12px -4px rgba(0, 0, 0, 0.15);
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        }

        ::v-deep tbody tr {
          transition: all 0.3s ease;

          &:hover {
            background: linear-gradient(
              135deg,
              #f0f4ff 0%,
              #e0e7ff 100%
            ) !important;
            transform: scale(1.01);
            box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);
          }

          td {
            font-size: 0.95rem;
            color: #2d3748;
            padding: 16px !important;
            border-bottom: 1px solid #e2e8f0 !important;
          }
        }

        ::v-deep .v-data-footer {
          border-top: 2px solid #e2e8f0;
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
          padding: 12px 16px;

          .v-data-footer__select {
            margin: 0 16px;
          }
        }

        .action-icon-btn {
          margin: 3px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

          &:hover {
            background-color: rgba(102, 126, 234, 0.1);
            transform: scale(1.15) rotate(5deg);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }
        }
      }
    }
  }

  // Animations
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  // Responsive design
  @media (max-width: 1024px) {
    padding: 16px;

    .main-card .header-section .headline-text {
      font-size: 1.75rem;
    }

    .summary-card {
      min-height: 160px !important;

      .summary-icon-container {
        width: 60px !important;
        height: 60px !important;
      }

      .summary-title {
        font-size: 1.05rem !important;
      }

      .summary-value {
        font-size: 2.5rem !important;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 12px;

    .main-card {
      border-radius: 16px !important;

      .header-section {
        flex-direction: column;
        padding: 24px 20px;

        .headline-text {
          margin-bottom: 16px !important;
          font-size: 1.5rem;
          text-align: center;
        }
      }

      .content-section {
        padding: 20px;
      }
    }

    .summary-card {
      min-height: 140px !important;

      .summary-card-content {
        padding: 24px 16px;
      }

      .summary-icon-container {
        width: 55px !important;
        height: 55px !important;
        margin-bottom: 12px !important;
      }

      .summary-title {
        font-size: 1rem !important;
        margin-bottom: 8px !important;
      }

      .summary-value {
        font-size: 2.2rem !important;
      }
    }

    .button-row .action-button {
      width: 100%;
      margin-bottom: 12px;
      padding: 20px 32px !important;
    }
  }

  @media (max-width: 480px) {
    padding: 8px;

    .main-card {
      border-radius: 12px !important;

      .header-section {
        padding: 20px 16px;

        .headline-text {
          font-size: 1.35rem;
        }
      }

      .content-section {
        padding: 16px;
      }
    }

    .records-count-container .records-count {
      font-size: 1.1rem;
      padding: 10px 24px;
    }

    .summary-card {
      min-height: 120px !important;

      .summary-card-content {
        padding: 20px 12px !important;
      }

      .summary-icon-container {
        width: 50px !important;
        height: 50px !important;
        margin-bottom: 10px !important;
      }

      .summary-title {
        font-size: 0.9rem !important;
        margin-bottom: 6px !important;
      }

      .summary-value {
        font-size: 2rem !important;
      }
    }

    .premium-data-table {
      ::v-deep thead {
        display: none;
      }

      ::v-deep tbody td {
        padding: 10px 8px !important;
        font-size: 0.85rem !important;
      }
    }

    .data-container .actions-row .action-buttons-container {
      flex-direction: column;
      width: 100%;

      .download-btn,
      .action-btn {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
